import { render } from "./createPublicStepComercialAddress.vue?vue&type=template&id=18a7d38f&scoped=true"
import script from "./createPublicStepComercialAddress.vue?vue&type=script&lang=js"
export * from "./createPublicStepComercialAddress.vue?vue&type=script&lang=js"

import "./createPublicStepComercialAddress.vue?vue&type=style&index=0&id=18a7d38f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a7d38f"]])

export default __exports__